module.exports = __webpack_public_path__ + "static/media/9.91fa7dbc.JPG";